import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import WhatsAppFloat from '@/components/WhatsAppFloat';
import { ArrowLeft, CheckCircle, Phone } from 'lucide-react';

const ServiceDetailPage = () => {
  const { slug } = useParams();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  const serviceDetails = {
    'klima-servisi': {
      title: 'Klima Servisi',
      description:
        'İzmir genelinde tüm klima markaları için montaj, bakım, arıza onarım ve gaz dolumu hizmetlerini uzman teknik ekibimizle sunuyoruz.',
      image: '/klima.png',
      details: [
        'Profesyonel montaj ve demontaj hizmetleri',
        'Yıllık periyodik bakım programı',
        'Hızlı arıza tespit ve onarım',
        'Orijinal yedek parça kullanımı',
        'Gaz dolumu ve basınç kontrolü',
        'Filtre temizliği ve dezenfeksiyonu',
        'Enerji verimliliği optimizasyonu',
        'Tüm markalar için servis desteği',
      ],
      meta_description:
        'İzmir klima servisi, montaj, bakım, gaz dolumu ve arıza onarım hizmetleri. Aden İklimlendirme ile 7/24 hızlı ve garantili teknik servis.',
    },
    'kombi-servisi': {
      title: 'Kombi Servisi',
      description:
        'Kombinizin güvenli ve verimli çalışması için bakım, arıza tespit ve onarım hizmetlerini profesyonel ekiplerimizle gerçekleştiriyoruz.',
      image: '/kombi.png',
      details: [
        'Yıllık kombi bakım ve kontrol',
        'Arıza tespit ve profesyonel tamir',
        'Petek temizliği ve sistem bakımı',
        'Gaz kaçağı tespiti ve onarım',
        'Yakıt verimliliği optimizasyonu',
        'Emniyet sistemleri kontrolü',
        'Orijinal yedek parça temini',
        'Tüm marka kombi servisi',
      ],
      meta_description:
        'İzmir kombi servisi, bakım, arıza onarım ve petek temizliği hizmetleri. Aynı gün servis ve uzman teknik ekip.',
    },
    'beyaz-esya-servisi': {
      title: 'Beyaz Eşya Servisi',
      description:
        'Çamaşır makinesi, bulaşık makinesi, buzdolabı ve ankastre ürünler için hızlı arıza tespit ve garantili onarım hizmeti sunuyoruz.',
      image: '/beyaz-esya.png',
      details: [
        'Çamaşır makinesi tamir ve bakım',
        'Bulaşık makinesi servisi',
        'Buzdolabı arıza onarım',
        'Fırın ve ankastre cihaz servisi',
        'Kurutucu arıza tamir',
        'Tüm markalarda uzman hizmet',
        'Orijinal yedek parça kullanımı',
        'Aynı gün servis seçeneği',
      ],
      meta_description:
        'İzmir beyaz eşya servisi. Çamaşır makinesi, bulaşık makinesi ve buzdolabı arıza onarım hizmetleri.',
    },
  };

  const service = serviceDetails[slug];

  if (!service) {
    return (
      <>
        <Navbar />
        <div className="min-h-screen flex items-center justify-center">
          <div className="text-center">
            <h1 className="text-3xl font-bold text-navy mb-4">Hizmet bulunamadı</h1>
            <Link to="/hizmetler" className="btn-primary">
              Hizmetlere Dön
            </Link>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Helmet>
        <title>
          {service.title} İzmir | Aden İklimlendirme Teknik Servis
        </title>
        <meta name="description" content={service.meta_description} />
      </Helmet>

      <Navbar />

      <section className="py-20 md:py-32" data-testid="service-detail-page">
        <div className="max-w-5xl mx-auto px-6 md:px-12">
          <div className="flex flex-col gap-3 mb-8">

            {/* Geri Dön Linki */}
            <Link
              to="/hizmetler"
              data-testid="back-to-services"
              className="inline-flex items-center text-orange hover:underline w-fit"
            >
              <ArrowLeft className="mr-2" size={20} />
              Hizmetlere Geri Dön
            </Link>

            {/* Breadcrumb */}
            <div className="text-sm text-slate-500">
              <Link to="/" className="hover:text-orange">Ana Sayfa</Link> /{" "}
              <Link to="/hizmetler" className="hover:text-orange">Hizmetler</Link> /{" "}
              <span className="text-navy font-medium">{service.title}</span>
            </div>

          </div>


          <div className="mb-12">
            <img src={"/images/hizmetler" + service.image} alt={`${service.title} İzmir teknik servis hizmeti`} className="w-full rounded-lg shadow-lg" />
          </div>

          <h1 className="text-4xl md:text-5xl font-bold text-navy mb-6">{service.title}</h1>
          <p className="text-lg text-slate-700 leading-relaxed mb-12">{service.description}</p>

          <div className="bg-light p-8 md:p-12 rounded-lg mb-12">
            <h2 className="text-3xl font-bold text-navy mb-8">Hizmet Detayları</h2>
            <div className="grid md:grid-cols-2 gap-6">
              {service.details.map((detail, index) => (
                <div key={index} className="flex items-start space-x-3">
                  <CheckCircle size={24} className="text-orange flex-shrink-0 mt-1" />
                  <span className="text-slate-700">{detail}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-navy text-white p-8 md:p-12 rounded-lg text-center">
            <h3 className="text-3xl font-bold mb-4">Hemen Randevu Alın</h3>
            <p className="text-slate-300 mb-8">
              <p className="text-slate-300 mb-8">
                7/24 servis desteği ve aynı gün müdahale ile arızalarınıza hızlı çözüm sunuyoruz.
              </p>
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/randevu" data-testid="service-randevu-button" className="btn-secondary">
                Online Randevu
              </Link>
              <a
                href="tel:+905063853685"
                onClick={() => {
                  if (window.gtag) {
                    window.gtag('event', 'conversion', {
                      send_to: 'AW-17944147746/P41VCLrutvYbEKLut-xC'
                    });
                  }
                }}
                data-testid="hero-phone-button"
                className="btn-outline !text-white !border-white hover:!bg-slate-100 hover:!text-[#EA580C] hover:!border-[#EA580C] inline-flex items-center justify-center"
              >
                <Phone className="mr-2" size={20} />
                +90 506 385 36 85
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <WhatsAppFloat />
    </>
  );
};

export default ServiceDetailPage;
